export const AppleIcon =
  'https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Apple_logo_white.svg/800px-Apple_logo_white.svg.png?20220116095718';

export const AppleIconOutLine =
  'https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg';
